const resolveLocalApiUrl = () => {
  if (typeof window === 'undefined') return '';
  const { hostname, port, protocol } = window.location;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  if (!isLocalhost) return '';
  if (port === '3001') return `${protocol}//${hostname}:3000`;
  if (port === '3000') return `${protocol}//${hostname}:3001`;
  return '';
};

const resolveHostedApiUrl = () => {
  if (typeof window === 'undefined') return '';
  const { hostname, protocol } = window.location;
  if (
    hostname === 'gestor.brutosdelivery.cloud' ||
    hostname === 'brutosdelivery.cloud' ||
    hostname === 'www.brutosdelivery.cloud'
  ) {
    return `${protocol}//backend.brutosdelivery.cloud`;
  }
  return '';
};

const resolveLocalBridgeUrl = () => {
  if (typeof window === 'undefined') return 'http://localhost:3001';
  const { hostname, port, protocol } = window.location;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  if (!isLocalhost) return 'http://localhost:3001';
  if (port === '3001') return `${protocol}//${hostname}:3000`;
  if (port === '3000') return `${protocol}//${hostname}:3001`;
  return `${protocol}//${hostname}:3001`;
};

export const getApiUrl = () => process.env.REACT_APP_API_URL || resolveLocalApiUrl() || resolveHostedApiUrl() || '';
export const getDefaultBridgeUrl = () => resolveLocalBridgeUrl();
